import React,{Component} from 'react';
import {Form,Input,Button} from 'antd'
import firebase from '../../config'

export default class Update extends Component{
    constructor(props){
        super(props);
        this.state={

            name:"hel",
            data:""
            
        }
    }
    componentDidMount(){
        var params= this.props.match.params
        firebase.firestore().collection('tests').doc(params.type).collection(params.category).doc("details").get().then(doc =>{
            console.log(doc.data())
            this.setState(doc.data())
        })
    }

    handleSubmit =() => {
        console.log(this.state)
            var params= this.props.match.params

        firebase.firestore().collection('tests').doc(params.type).collection(params.category).doc("details").update(this.state).then(()=>{
            alert("updated")
        })
    }
    render(){
        var data = this.state
        return(
            <div>
                <Form >
                    <Form.Item  label="name">
                        <Input value={data.name} name="name" onChange={(e)=>this.setState({"name":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="Description">
                        <Input value={data.data} name="Description" onChange={(e)=>this.setState({"data":e.target.value})}/>
                    </Form.Item>
                    <Form.Item  label="name">
                        <Button onClick={this.handleSubmit} >Submit</Button>

                    </Form.Item>
                </Form>
            </div>
        )
    }
}